import Icon from "../../../icons/Icon"

const FormError = ({formError, errors, setRemoveErrors}) => {
    if(formError){
        return  <div className='w-100 d-flex align-items-center rounded justify-content-center py-2'>
        <span onClick={() => setRemoveErrors(true)} type="button" ><Icon name="ICON_WARNING" className="text-danger" /></span>
        <h6 className='w-100 text-center text-danger mt-3 mb-1 pb-3'>{formError}</h6>
    </div>
        
    }
    else if(errors && errors.length > 0){
        return <div className='w-100 d-flex align-items-center rounded justify-content-center alert-warning py-2'>
            <span onClick={() => setRemoveErrors(true)} type="button" ><Icon name="ICON_WARNING" className="text-danger" /></span>
            <h6 className='ms-2 text-center mb-0 text-dark'>{errors.join(', ')}</h6>
        </div>
    }
    return 

}

export default FormError
